<script lang="ts">
  type Color =
    | 'primary'
    | 'success'
    | 'warning'
    | 'error'
    | 'on-primary'
    | 'surface'

  export let icon:
    | 'apple'
    | 'google'
    | 'apple-pay'
    | 'google-pay'
    | 'se_bank_id'
    | 'no_bank_id'
    | 'dk_mit_id'
    | 'bruce'
    | string

  export let size: number | undefined = undefined
  export let color: Color | undefined = undefined
  export let backgroundColor: Color | undefined = undefined
  export let rounded: boolean | undefined = undefined

  function setStyle() {
    let style = ''
    style = size ? `--icon-size: ${size}em;` : style
    style = color ? `${style} --icon-color: var(--color-${color});` : style
    style = backgroundColor
      ? `${style} --icon-background-color: var(--color-${backgroundColor});`
      : style

    return style || undefined
  }
</script>

{#if icon === 'apple'}
  <i class:icon class:rounded class="apple" style={setStyle()}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M14.0622 10.6254C14.0388 8.09639 16.1991 6.88225 16.2968 6.82305C15.0811 5.10388 13.1893 4.86836 12.5143 4.84065C10.9052 4.68321 9.37293 5.75628 8.55729 5.75628C7.74164 5.75628 6.48039 4.86332 5.14617 4.88851C3.3898 4.9137 1.77284 5.87468 0.868597 7.3936C-0.954226 10.4503 0.403447 14.9807 2.17806 17.4618C3.04713 18.6747 4.08166 20.0412 5.44194 19.9908C6.7527 19.9405 7.24783 19.1722 8.8296 19.1722C10.4114 19.1722 10.857 19.9908 12.242 19.9669C13.6505 19.9405 14.5443 18.7276 15.4069 17.5109C16.4023 16.1028 16.8141 14.7401 16.8375 14.6683C16.8062 14.6557 14.0909 13.6494 14.0622 10.6254Z"
          fill="white"
        />
        <path
          d="M11.4602 3.19929C12.182 2.35418 12.6693 1.17908 12.5351 0.0078125C11.4953 0.0481592 10.2367 0.677865 9.49009 1.52297C8.82169 2.26987 8.23537 3.46634 8.39425 4.61375C9.55392 4.70066 10.7383 4.04315 11.4602 3.19929Z"
          fill="white"
        />
      </g>
    </svg>
  </i>
{:else if icon === 'google'}
  <i class:icon class:rounded class="google" style={setStyle()}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M19.1899 10.1873C19.1899 9.36791 19.1245 8.76998 18.9832 8.1499H9.79123V11.8482H15.1867C15.078 12.7673 14.4905 14.1514 13.1852 15.0815L13.1669 15.2053L16.0732 17.4971L16.2745 17.5176C18.1238 15.7791 19.1899 13.2213 19.1899 10.1873Z"
          fill="#4285F4"
        />
        <path
          d="M9.79122 19.9312C12.4345 19.9312 14.6536 19.0453 16.2745 17.5173L13.1851 15.0812C12.3584 15.6681 11.2488 16.0778 9.79122 16.0778C7.20226 16.0778 5.00492 14.3394 4.22163 11.9365L4.10681 11.9464L1.08478 14.3271L1.04526 14.439C2.65519 17.6944 5.96212 19.9312 9.79122 19.9312Z"
          fill="#34A853"
        />
        <path
          d="M4.22165 11.9368C4.01497 11.3167 3.89535 10.6523 3.89535 9.96583C3.89535 9.27927 4.01497 8.61492 4.21077 7.99484L4.2053 7.86278L1.14539 5.44385L1.04527 5.49232C0.381743 6.84324 0.00100708 8.36026 0.00100708 9.96583C0.00100708 11.5714 0.381743 13.0884 1.04527 14.4393L4.22165 11.9368Z"
          fill="#FBBC05"
        />
        <path
          d="M9.79124 3.85336C11.6296 3.85336 12.8697 4.66168 13.5768 5.33717L16.3398 2.59107C14.6429 0.985496 12.4346 0 9.79124 0C5.96213 0 2.65519 2.23672 1.04526 5.49214L4.21076 7.99466C5.00493 5.59183 7.20228 3.85336 9.79124 3.85336Z"
          fill="#EB4335"
        />
      </g>
    </svg>
  </i>
{:else if icon === 'apple-pay'}
  <i class:icon class:rounded class="apple-pay" style={setStyle()}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 165.52107 105.9651"
      enable-background="new 0 0 165.52107 105.9651"
    >
      <g>
        <path
          d="M150.69807,0H14.82318c-0.5659,0-1.1328,0-1.69769,0.0033c-0.47751,0.0034-0.95391,0.0087-1.43031,0.0217
		c-1.039,0.0281-2.0869,0.0894-3.1129,0.2738c-1.0424,0.1876-2.0124,0.4936-2.9587,0.9754
		c-0.9303,0.4731-1.782,1.0919-2.52009,1.8303c-0.73841,0.7384-1.35721,1.5887-1.83021,2.52
		c-0.4819,0.9463-0.7881,1.9166-0.9744,2.9598c-0.18539,1.0263-0.2471,2.074-0.2751,3.1119
		c-0.0128,0.4764-0.01829,0.9528-0.0214,1.4291c-0.0033,0.5661-0.0022,1.1318-0.0022,1.6989V91.142
		c0,0.5671-0.0011,1.13181,0.0022,1.69901c0.00311,0.4763,0.0086,0.9527,0.0214,1.4291
		c0.028,1.03699,0.08971,2.08469,0.2751,3.11069c0.1863,1.0436,0.4925,2.0135,0.9744,2.9599
		c0.473,0.9313,1.0918,1.7827,1.83021,2.52c0.73809,0.7396,1.58979,1.3583,2.52009,1.8302
		c0.9463,0.4831,1.9163,0.7892,2.9587,0.9767c1.026,0.1832,2.0739,0.2456,3.1129,0.2737c0.4764,0.0108,0.9528,0.0172,1.43031,0.0194
		c0.56489,0.0044,1.13179,0.0044,1.69769,0.0044h135.87489c0.5649,0,1.13181,0,1.69659-0.0044
		c0.47641-0.0022,0.95282-0.0086,1.4314-0.0194c1.0368-0.0281,2.0845-0.0905,3.11301-0.2737
		c1.041-0.1875,2.0112-0.4936,2.9576-0.9767c0.9313-0.4719,1.7805-1.0906,2.52011-1.8302c0.7372-0.7373,1.35599-1.5887,1.8302-2.52
		c0.48299-0.9464,0.78889-1.9163,0.97429-2.9599c0.1855-1.026,0.2457-2.0737,0.2738-3.11069
		c0.013-0.4764,0.01941-0.9528,0.02161-1.4291c0.00439-0.5672,0.00439-1.1319,0.00439-1.69901V14.8242
		c0-0.5671,0-1.1328-0.00439-1.6989c-0.0022-0.4763-0.00861-0.9527-0.02161-1.4291c-0.02811-1.0379-0.0883-2.0856-0.2738-3.1119
		c-0.18539-1.0432-0.4913-2.0135-0.97429-2.9598c-0.47421-0.9313-1.093-1.7816-1.8302-2.52
		c-0.73961-0.7384-1.58881-1.3572-2.52011-1.8303c-0.9464-0.4818-1.9166-0.7878-2.9576-0.9754
		c-1.0285-0.1844-2.0762-0.2457-3.11301-0.2738c-0.47858-0.013-0.95499-0.0183-1.4314-0.0217C151.82988,0,151.26297,0,150.69807,0
		L150.69807,0z"
        />
        <path
          fill="#FFFFFF"
          d="M150.69807,3.532l1.67149,0.0032c0.4528,0.0032,0.90561,0.0081,1.36092,0.0205
		c0.79201,0.0214,1.71849,0.0643,2.58209,0.2191c0.7507,0.1352,1.38029,0.3408,1.9845,0.6484
		c0.5965,0.3031,1.14301,0.7003,1.62019,1.1768c0.479,0.4797,0.87671,1.0271,1.18381,1.6302
		c0.30589,0.5995,0.51019,1.2261,0.64459,1.9823c0.1544,0.8542,0.1971,1.7832,0.21881,2.5801
		c0.01219,0.4498,0.01819,0.8996,0.0204,1.3601c0.00429,0.5569,0.0042,1.1135,0.0042,1.6715V91.142
		c0,0.558,0.00009,1.1136-0.0043,1.6824c-0.00211,0.4497-0.0081,0.8995-0.0204,1.3501c-0.02161,0.7957-0.0643,1.7242-0.2206,2.5885
		c-0.13251,0.7458-0.3367,1.3725-0.64429,1.975c-0.30621,0.6016-0.70331,1.1484-1.18022,1.6251
		c-0.47989,0.48-1.0246,0.876-1.62819,1.1819c-0.5997,0.3061-1.22821,0.51151-1.97151,0.6453
		c-0.88109,0.157-1.84639,0.2002-2.57339,0.2199c-0.4574,0.0103-0.9126,0.01649-1.37889,0.0187
		c-0.55571,0.0043-1.1134,0.0042-1.6692,0.0042H14.82318c-0.0074,0-0.0146,0-0.0221,0c-0.5494,0-1.0999,0-1.6593-0.0043
		c-0.4561-0.00211-0.9112-0.0082-1.3512-0.0182c-0.7436-0.0201-1.7095-0.0632-2.5834-0.2193
		c-0.74969-0.1348-1.3782-0.3402-1.9858-0.6503c-0.59789-0.3032-1.1422-0.6988-1.6223-1.1797
		c-0.4764-0.4756-0.8723-1.0207-1.1784-1.6232c-0.3064-0.6019-0.5114-1.2305-0.64619-1.9852
		c-0.15581-0.8626-0.19861-1.7874-0.22-2.5777c-0.01221-0.4525-0.01731-0.9049-0.02021-1.3547l-0.0022-1.3279l0.0001-0.3506V14.8242
		l-0.0001-0.3506l0.0021-1.3251c0.003-0.4525,0.0081-0.9049,0.02031-1.357c0.02139-0.7911,0.06419-1.7163,0.22129-2.5861
		c0.1336-0.7479,0.3385-1.3765,0.6465-1.9814c0.3037-0.5979,0.7003-1.1437,1.17921-1.6225
		c0.477-0.4772,1.02309-0.8739,1.62479-1.1799c0.6011-0.3061,1.2308-0.5116,1.9805-0.6465c0.8638-0.1552,1.7909-0.198,2.5849-0.2195
		c0.4526-0.0123,0.9052-0.0172,1.3544-0.0203l1.6771-0.0033H150.69807"
        />
        <g>
          <g>
            <path
              d="M45.1862,35.64053c1.41724-1.77266,2.37897-4.15282,2.12532-6.58506c-2.07464,0.10316-4.60634,1.36871-6.07207,3.14276
				c-1.31607,1.5192-2.4809,3.99902-2.17723,6.3293C41.39111,38.72954,43.71785,37.36345,45.1862,35.64053"
            />
            <path
              d="M47.28506,38.98252c-3.38211-0.20146-6.25773,1.91951-7.87286,1.91951c-1.61602,0-4.08931-1.81799-6.76438-1.76899
				c-3.48177,0.05114-6.71245,2.01976-8.4793,5.15079c-3.63411,6.2636-0.95904,15.55471,2.57494,20.65606
				c1.71618,2.5238,3.78447,5.30269,6.50976,5.20287c2.57494-0.10104,3.58421-1.66732,6.71416-1.66732
				c3.12765,0,4.03679,1.66732,6.76252,1.61681c2.82665-0.05054,4.59381-2.52506,6.30997-5.05132
				c1.96878-2.877,2.77473-5.65498,2.82542-5.80748c-0.0507-0.05051-5.45058-2.12204-5.50065-8.33358
				c-0.05098-5.20101,4.23951-7.6749,4.44144-7.82832C52.3832,39.4881,48.5975,39.08404,47.28506,38.98252"
            />
          </g>
          <g>
            <path
              d="M76.73385,31.94381c7.35096,0,12.4697,5.06708,12.4697,12.44437c0,7.40363-5.22407,12.49704-12.65403,12.49704h-8.13892
				v12.94318h-5.88037v-37.8846H76.73385z M68.41059,51.9493h6.74732c5.11975,0,8.0336-2.75636,8.0336-7.53479
				c0-4.77792-2.91385-7.50845-8.00727-7.50845h-6.77365V51.9493z"
            />
            <path
              d="M90.73997,61.97864c0-4.8311,3.70182-7.79761,10.26583-8.16526l7.56061-0.44614v-2.12639
				c0-3.07185-2.07423-4.90959-5.53905-4.90959c-3.28251,0-5.33041,1.57492-5.82871,4.04313h-5.35574
				c0.31499-4.98859,4.56777-8.66407,11.3941-8.66407c6.69466,0,10.97377,3.54432,10.97377,9.08388v19.03421h-5.43472v-4.54194
				h-0.13065c-1.60125,3.07185-5.09341,5.01441-8.71623,5.01441C94.52078,70.30088,90.73997,66.94038,90.73997,61.97864z
				 M108.56641,59.4846v-2.17905l-6.8,0.41981c-3.38683,0.23649-5.30306,1.73291-5.30306,4.09579
				c0,2.41504,1.99523,3.99046,5.04075,3.99046C105.46823,65.81161,108.56641,63.08108,108.56641,59.4846z"
            />
            <path
              d="M119.34167,79.9889v-4.5946c0.4193,0.10483,1.36425,0.10483,1.83723,0.10483c2.6252,0,4.04313-1.10245,4.90908-3.9378
				c0-0.05267,0.49931-1.68025,0.49931-1.70658l-9.97616-27.64562h6.14268l6.98432,22.47371h0.10432l6.98433-22.47371h5.9857
				l-10.34483,29.06304c-2.36186,6.69517-5.0924,8.84789-10.81577,8.84789C121.17891,80.12006,119.76098,80.06739,119.34167,79.9889
				z"
            />
          </g>
        </g>
      </g>
    </svg>
  </i>
{:else if icon === 'google-pay'}
  <i class:icon class:rounded class="google-pay" style={setStyle()}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 1094 742"
      enable-background="new 0 0 1094 742"
    >
      <path
        fill="#FFFFFF"
        d="M722.7,170h-352c-110,0-200,90-200,200l0,0c0,110,90,200,200,200h352c110,0,200-90,200-200l0,0
	C922.7,260,832.7,170,722.7,170z"
      />
      <path
        fill="#3C4043"
        d="M722.7,186.2c24.7,0,48.7,4.9,71.3,14.5c21.9,9.3,41.5,22.6,58.5,39.5
	c16.9,16.9,30.2,36.6,39.5,58.5c9.6,22.6,14.5,46.6,14.5,71.3s-4.9,48.7-14.5,71.3c-9.3,21.9-22.6,41.5-39.5,58.5
	c-16.9,16.9-36.6,30.2-58.5,39.5c-22.6,9.6-46.6,14.5-71.3,14.5h-352c-24.7,0-48.7-4.9-71.3-14.5c-21.9-9.3-41.5-22.6-58.5-39.5
	c-16.9-16.9-30.2-36.6-39.5-58.5c-9.6-22.6-14.5-46.6-14.5-71.3s4.9-48.7,14.5-71.3c9.3-21.9,22.6-41.5,39.5-58.5
	c16.9-16.9,36.6-30.2,58.5-39.5c22.6-9.6,46.6-14.5,71.3-14.5L722.7,186.2 M722.7,170h-352c-110,0-200,90-200,200l0,0
	c0,110,90,200,200,200h352c110,0,200-90,200-200l0,0C922.7,260,832.7,170,722.7,170L722.7,170z"
      />
      <g>
        <g>
          <path
            fill="#3C4043"
            d="M529.3,384.2v60.5h-19.2V295.3H561c12.9,0,23.9,4.3,32.9,12.9
			c9.2,8.6,13.8,19.1,13.8,31.5c0,12.7-4.6,23.2-13.8,31.7c-8.9,8.5-19.9,12.7-32.9,12.7h-31.7V384.2z M529.3,313.7v52.1h32.1
			c7.6,0,14-2.6,19-7.7c5.1-5.1,7.7-11.3,7.7-18.3c0-6.9-2.6-13-7.7-18.1c-5-5.3-11.3-7.9-19-7.9h-32.1V313.7z"
          />
          <path
            fill="#3C4043"
            d="M657.9,339.1c14.2,0,25.4,3.8,33.6,11.4c8.2,7.6,12.3,18,12.3,31.2v63h-18.3v-14.2h-0.8
			c-7.9,11.7-18.5,17.5-31.7,17.5c-11.3,0-20.7-3.3-28.3-10s-11.4-15-11.4-25c0-10.6,4-19,12-25.2c8-6.3,18.7-9.4,32-9.4
			c11.4,0,20.8,2.1,28.1,6.3v-4.4c0-6.7-2.6-12.3-7.9-17c-5.3-4.7-11.5-7-18.6-7c-10.7,0-19.2,4.5-25.4,13.6l-16.9-10.6
			C625.9,345.8,639.7,339.1,657.9,339.1z M633.1,413.3c0,5,2.1,9.2,6.4,12.5c4.2,3.3,9.2,5,14.9,5c8.1,0,15.3-3,21.6-9
			s9.5-13,9.5-21.1c-6-4.7-14.3-7.1-25-7.1c-7.8,0-14.3,1.9-19.5,5.6C635.7,403.1,633.1,407.8,633.1,413.3z"
          />
          <path
            fill="#3C4043"
            d="M808.2,342.4l-64,147.2h-19.8l23.8-51.5L706,342.4h20.9l30.4,73.4h0.4l29.6-73.4H808.2z"
          />
        </g>
        <g>
          <path
            fill="#4285F4"
            d="M452.93,372c0-6.26-0.56-12.25-1.6-18.01h-80.48v33L417.2,387
			c-1.88,10.98-7.93,20.34-17.2,26.58v21.41h27.59C443.7,420.08,452.93,398.04,452.93,372z"
          />
          <path
            fill="#34A853"
            d="M400.01,413.58c-7.68,5.18-17.57,8.21-29.14,8.21c-22.35,0-41.31-15.06-48.1-35.36
			h-28.46v22.08c14.1,27.98,43.08,47.18,76.56,47.18c23.14,0,42.58-7.61,56.73-20.71L400.01,413.58z"
          />
          <path
            fill="#FABB05"
            d="M320.09,370.05c0-5.7,0.95-11.21,2.68-16.39v-22.08h-28.46
			c-5.83,11.57-9.11,24.63-9.11,38.47s3.29,26.9,9.11,38.47l28.46-22.08C321.04,381.26,320.09,375.75,320.09,370.05z"
          />
          <path
            fill="#E94235"
            d="M370.87,318.3c12.63,0,23.94,4.35,32.87,12.85l24.45-24.43
			c-14.85-13.83-34.21-22.32-57.32-22.32c-33.47,0-62.46,19.2-76.56,47.18l28.46,22.08C329.56,333.36,348.52,318.3,370.87,318.3z"
          />
        </g>
      </g>
    </svg>
  </i>
{:else if icon === 'se_bank_id'}
  <i class:icon class:rounded class="se-bank-id" style={setStyle()}>
    <svg
      version="1.1"
      id="Lager_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      viewBox="0 0 619.2 513"
      style="enable-background:new 0 0 619.2 513;"
      xml:space="preserve"
    >
      <style type="text/css">
        .st0 {
          fill: var(
            --icon-color,
            var(--se-bank-id-icon-color, var(--color-on-background))
          );
        }
        .st1 {
          fill: none;
        }
      </style>
      <g>
        <path
          class="st0"
          d="M251.3,263.4l13.2-83.2c-5.2,0-14.1,0-14.1,0c-6.6,0-15.1-3.7-17.6-10.5c-0.8-2.3-2.7-10.2,8.2-17.9
		c3.9-2.7,6.4-5.7,6.9-8c0.5-2.4-0.1-4.5-1.8-6.1c-2.4-2.3-7.1-3.6-13.1-3.6c-10.1,0-17.2,5.8-17.9,10c-0.5,3.1,1.9,5.6,4,7.2
		c6.3,4.7,7.8,11.5,3.9,17.9c-4,6.6-12.7,10.9-22,11c0,0-9.2,0-14.4,0c-1.2,8.1-20.8,132.3-22.3,142.1h77.8
		C242.8,318,246.4,294.5,251.3,263.4L251.3,263.4z"
        />
        <g>
          <path
            class="st0"
            d="M160.1,351.1H192c13.6,0,16.9,6.9,15.9,13.2c-0.8,5.1-4.3,8.9-10.3,11.4c7.6,2.9,10.6,7.4,9.5,14.5
			c-1.4,8.9-9.1,15.5-19.2,15.5h-36.3L160.1,351.1z M181.2,373.7c6.2,0,9.1-3.3,9.7-7.2c0.6-4.2-1.3-7.1-7.5-7.1h-5.5l-2.2,14.3
			H181.2z M177.8,397.2c6.4,0,10.1-2.6,11-7.9c0.7-4.6-1.9-7.3-8.1-7.3h-6.2l-2.4,15.3H177.8z"
          />
          <path
            class="st0"
            d="M251.8,406.1c-8.3,0.6-12.3-0.3-14.3-3.9c-4.4,2.7-9.3,4.1-14.5,4.1c-9.4,0-12.7-4.9-11.8-10.3
			c0.4-2.6,1.9-5.1,4.3-7.2c5.2-4.5,18-5.1,23-8.5c0.4-3.8-1.1-5.2-5.8-5.2c-5.5,0-10.1,1.8-18,7.2l1.9-12.4
			c6.8-4.9,13.4-7.2,21-7.2c9.7,0,18.3,4,16.7,14.6l-1.9,12c-0.7,4.2-0.5,5.5,4.2,5.6L251.8,406.1z M237.4,387.2
			c-4.4,2.8-12.6,2.3-13.5,8.1c-0.4,2.7,1.3,4.7,4,4.7c2.6,0,5.8-1.1,8.4-2.9c-0.2-1-0.1-2,0.2-3.9L237.4,387.2z"
          />
          <path
            class="st0"
            d="M267.3,363.4h16.6l-0.9,5.5c5.3-4.5,9.3-6.2,14.5-6.2c9.3,0,13.6,5.7,12.1,15l-4.3,27.9h-16.6l3.6-23.1
			c0.7-4.2-0.6-6.2-3.8-6.2c-2.6,0-5,1.4-7.3,4.5l-3.8,24.7h-16.6L267.3,363.4z"
          />
          <path
            class="st0"
            d="M322.6,351.1h16.6l-4.2,26.8l15.9-14.5h20.5l-20.4,18l16.4,24.2h-20.9L333.9,386h-0.2l-3,19.5h-16.6
			L322.6,351.1z"
          />
        </g>
        <path class="st0" d="M381.3,351.1h19.1l-8.4,54.5h-19.1L381.3,351.1z" />
        <path
          class="st0"
          d="M409.7,351.1H437c21.1,0,27.2,15.3,25.2,28c-1.9,12.4-11.7,26.5-30.2,26.5h-30.8L409.7,351.1z M427.4,392.6
		c9.3,0,14.4-4.6,15.9-14.3c1.1-7.2-1.1-14.3-11.4-14.3h-5.1l-4.4,28.6H427.4z"
        />
        <path
          class="st0"
          d="M355.9,107.5h-79.5l-10.6,67.3l13.5,0c7.4,0,14.4-3.4,17.4-8.3c1-1.6,1.4-3,1.4-4.3c0-2.8-1.9-4.9-3.8-6.3
		c-5.2-3.9-6.3-8-6.3-10.9c0-0.6,0-1.1,0.1-1.6c1.1-7.1,10.7-14.8,23.4-14.8c7.6,0,13.4,1.8,16.9,5.1c3.1,2.9,4.3,7,3.4,11.3
		c-1.1,5.1-6.2,9.3-9.1,11.4c-7.7,5.4-6.7,10.1-6.2,11.5c1.6,4.2,7.7,6.9,12.4,6.9h20.6c0,0,0,0,0,0.1c28,0.2,43,13.1,38.3,43.1
		c-4.4,27.9-25.8,39.9-51.3,40.1l-10.1,64.4h14.9c62.9,0,114.3-40.4,124.4-104.2C478.2,139.1,427.9,107.5,355.9,107.5z"
        />
      </g>
      <rect class="st1" width="619.2" height="513" />
    </svg>
  </i>
{:else if icon === 'no_bank_id'}
  <i class:icon class:rounded class="no-bank-id" style={setStyle()}>
    <svg viewBox="0 0 156 24" focusable="false" width="100%" height="100%">
      <style type="text/css">
        .fill {
          fill: var(
            --icon-color,
            var(--no-bank-id-icon-color, var(--color-on-background))
          );
        }
      </style>
      <g id="BankID_Main_Logo 1" clip-path="url(#clip0_691_17062)" class="fill">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M7.5 3H1.5C0.7 3 0 2.3 0 1.5C0 0.7 0.7 0 1.5 0H7.5C8.3 0 9 0.7 9 1.5C9 2.3 8.3 3 7.5 3Z"
            />
            <path
              id="Vector_2"
              d="M7.5 15H1.5C0.7 15 0 14.3 0 13.5C0 12.7 0.7 12 1.5 12H7.5C8.3 12 9 12.7 9 13.5C9 14.3 8.3 15 7.5 15Z"
            />
            <path
              id="Vector_3"
              d="M7.5 21H1.5C0.7 21 0 20.3 0 19.5C0 18.7 0.7 18 1.5 18H7.5C8.3 18 9 18.7 9 19.5C9 20.3 8.3 21 7.5 21Z"
            />
            <path
              id="Vector_4"
              d="M19.5 9H13.5C12.7 9 12 8.3 12 7.5C12 6.7 12.7 6 13.5 6H19.5C20.3 6 21 6.7 21 7.5C21 8.3 20.3 9 19.5 9Z"
            />
            <path
              id="Vector_5"
              d="M19.5 15H13.5C12.7 15 12 14.3 12 13.5C12 12.7 12.7 12 13.5 12H19.5C20.3 12 21 12.7 21 13.5C21 14.3 20.3 15 19.5 15Z"
            />
            <path
              id="Vector_6"
              d="M31.5 3H25.5C24.7 3 24 2.3 24 1.5C24 0.7 24.7 0 25.5 0H31.5C32.3 0 33 0.7 33 1.5C33 2.3 32.3 3 31.5 3Z"
            />
            <path
              id="Vector_7"
              d="M31.5 9H25.5C24.7 9 24 8.3 24 7.5C24 6.7 24.7 6 25.5 6H31.5C32.3 6 33 6.7 33 7.5C33 8.3 32.3 9 31.5 9Z"
            />
            <path
              id="Vector_8"
              d="M31.5 21H25.5C24.7 21 24 20.3 24 19.5C24 18.7 24.7 18 25.5 18H31.5C32.3 18 33 18.7 33 19.5C33 20.3 32.3 21 31.5 21Z"
            />
          </g>
          <g id="Group_3">
            <path
              id="Vector_9"
              d="M45.8 13.1C45.8 16.3 47.6 18 49.7 18C51.6 18 53.7 16.4 53.7 13.1C53.7 9.8 51.7 8.3 49.8 8.3C47.7 8.3 45.8 9.8 45.8 13.1ZM45.8 0V7.8C46.7 6.4 48.3 5 51 5C54 5 57.6 7.5 57.6 13C57.6 18.7 54.2 21.5 50.7 21.5C48.7 21.5 47 20.6 45.9 18.8V21H42V0H45.8Z"
            />
            <path
              id="Vector_10"
              d="M63.3 13.2C63.3 16.5 65.3 18 67.2 18C69.3 18 71.1 16.6 71.1 13.2C71.1 9.89999 69.3 8.29999 67.2 8.29999C65.4 8.29999 63.3 9.79999 63.3 13.2ZM59.5 13C59.5 7.59999 63 4.89999 66.5 4.89999C68.4 4.89999 70 5.59999 71.2 7.29999V5.29999H75V21H71.2V18.8C70.1 20.3 68.5 21.4 66 21.4C63 21.4 59.5 18.8 59.5 13Z"
            />
            <path
              id="Vector_11"
              d="M82.5 12.1V21H78.7V5.4H82.5V7.7C83.6 5.7 85.6 5 87.3 5C90 5 92.6 6.4 92.6 10.6V21H88.8V12C88.8 9.4 87.5 8.4 85.8 8.4C83.9 8.5 82.5 9.6 82.5 12.1Z"
            />
            <path
              id="Vector_12"
              d="M96.2 0V21H100V17.2L102.1 14.6L106.4 21H110.6L104.4 11.9L109.8 5.4H105.5L100 12.6V0H96.2Z"
            />
            <path id="Vector_13" d="M118.2 0.700012H114.3V21H118.2V0.700012Z" />
            <path
              id="Vector_14"
              d="M129.5 0.700012H122.1V21H129.5C135 21 139.6 17.7 139.6 10.8C139.6 4.00001 135 0.700012 129.5 0.700012ZM129.5 17.4H126V4.30001H129.5C132.7 4.30001 135.4 6.40001 135.4 10.9C135.4 15.3 132.7 17.4 129.5 17.4Z"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_691_17062">
          <rect width="140" height="21" />
        </clipPath>
      </defs>
    </svg>
  </i>
{:else if icon === 'dk_mit_id'}
  <i class:icon class:rounded class="dk-mit-id" style={setStyle()}>
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      viewBox="0 0 61 16"
      style="enable-background:new 0 0 61 16;"
      xml:space="preserve"
    >
      <style type="text/css">
        .st0 {
          clip-path: url(#SVGID_2_);
          fill: var(
            --icon-color,
            var(--dk-mit-id-icon-color, var(--color-on-background))
          );
        }
      </style>
      <g>
        <defs>
          <path
            id="SVGID_1_"
            d="M19.2,0c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8C17.4,0.8,18.2,0,19.2,0z M40.4,0
			c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8C36.6,1.7,38.3,0,40.4,0z M20.7,4.9v10.9h-3V4.9H20.7z
			 M2.9,0.8l4.6,7.1l4.5-7.1h2.9v15h-3.1V6.1l-4.3,6.4H7.4L3.1,6.1v9.7H0v-15H2.9z M40.4,9c3.6,0,6.5,2,6.9,6.8H33.6
			C34,11,36.9,9,40.4,9z M51.9,0.2C58.3,0.2,61,3.7,61,8c0,4.3-2.7,7.8-9.1,7.8h-2.6V0.2H51.9z M27.1,1.9v3h2.4v2.4h-2.4v4.8
			c0,0.9,0.5,1.2,1.3,1.2c0.5,0,1-0.1,1.3-0.4v2.7c-0.4,0.2-1.2,0.3-2,0.3c-2.2,0-3.6-1.1-3.6-3.5V7.3h-1.7V4.9h1.7v-3H27.1z"
          />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow:visible;" />
        </clipPath>
        <rect x="0" y="-0.6" class="st0" width="62" height="18" />
      </g>
    </svg>
  </i>
{:else if icon === 'bruce'}
  <i class:icon class:rounded class="bruce" style={setStyle()}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 150.13 152.62"
      width="100%"
      height="100%"
    >
      <defs>
        <style>
          .cls-1 {
            fill: var(
              --icon-color,
              var(--bruce-icon-color, var(--color-on-background))
            );
          }
        </style>
      </defs>
      <g>
        <g id="Lager_1">
          <g>
            <path
              class="cls-1"
              d="M87.1,29.2c7.28,0,11.59,1.58,14.77,5,2.73,2.73,4.54,6.36,4.54,10.67,0,4.54-1.82,8.86-5,12.04-3.41,3.4-8.18,4.77-14.31,4.77h-52.23V29.2h52.23ZM92.55,86.2c7.05,0,12.28,2.26,16.36,6.35,3.17,3.41,5.22,7.73,5.22,12.5s-2.05,9.54-5.22,12.95c-3.87,3.62-9.54,5.67-16.36,5.67h-57.68v-37.47h57.68ZM93.69,150.47c20.22,0,31.34-4.77,40.42-13.39,9.31-9.08,13.85-20,13.85-31.79,0-17.27-9.31-30.9-26.57-36.8,10.9-5.67,18.62-17.03,18.62-29.74,0-8.41-3.4-16.13-9.32-22.26-8.16-8.63-21.34-14.31-39.74-14.31H2.17v148.3h91.53Z"
            />
            <path
              class="cls-1"
              d="M93.69,152.62H0V0h90.97c17.75,0,32.03,5.18,41.3,14.99,6.48,6.7,9.91,14.92,9.91,23.75,0,11.52-6.12,22.61-15.91,29.33,15.22,6.77,23.85,20.12,23.85,37.21,0,12.55-5.01,24.08-14.5,33.34-10.49,9.96-22.63,14-41.94,14ZM4.32,148.3h89.37c18.07,0,29.36-3.71,38.94-12.8,8.73-8.53,13.17-18.71,13.17-30.23,0-16.62-9.15-29.29-25.11-34.74l-.3-3.97c10.61-5.52,17.47-16.44,17.47-27.83,0-7.68-3.02-14.86-8.72-20.75-8.45-8.95-21.64-13.67-38.17-13.67H4.32v143.98ZM92.56,125.83h-59.85v-41.78h59.85c7.35,0,13.21,2.28,17.89,6.98,3.84,4.13,5.84,8.96,5.84,14.03s-2.16,10.53-5.79,14.43c-4.47,4.19-10.62,6.35-17.94,6.35ZM37.02,121.5h55.53c6.19,0,11.34-1.76,14.87-5.08,2.8-3.02,4.54-7.3,4.54-11.37,0-5-2.52-8.75-4.64-11.02-3.78-3.79-8.63-5.66-14.78-5.66h-55.53v33.14ZM87.1,63.84h-54.4V27.03h54.4c7.74,0,12.63,1.7,16.36,5.69,3.33,3.34,5.12,7.56,5.12,12.14,0,5.11-1.99,9.94-5.63,13.57-3.67,3.65-8.85,5.41-15.85,5.41ZM37.02,59.51h50.07c5.88,0,9.95-1.32,12.8-4.14,2.8-2.82,4.36-6.56,4.36-10.51,0-4.31-2.12-7.35-3.91-9.15-2.87-3.07-6.82-4.36-13.24-4.36h-50.07v28.16Z"
            />
          </g>
        </g>
      </g>
    </svg>
  </i>
{:else}
  <i
    class={icon.replace('-fill', '').replace('-thin', '')}
    class:ph={icon.startsWith('ph-') &&
      !icon.endsWith('-fill') &&
      !icon.endsWith('-thin')}
    class:ph-fill={icon.startsWith('ph-') && icon.endsWith('-fill')}
    class:ph-thin={icon.startsWith('ph-') && icon.endsWith('-thin')}
    class:fi={icon.startsWith('fi-')}
    class:icon
    class:rounded
    style={setStyle()}
  ></i>
{/if}

<style lang="scss">
  .icon {
    position: relative;
    display: flex;
    justify-content: center;
    font-size: var(--icon-size, 1.5em);
    color: var(--icon-color, var(--color-on-background));
    background-color: var(--icon-background-color, transparent);
    margin: var(--icon-margin, 0 0.25em);
    min-width: 1em;
    min-height: 1em;
    transition: color 150ms ease-in-out;

    &.rounded {
      border-radius: 50%;
      height: max-content;
      width: max-content;
      padding: 0.5em;
    }
  }

  .icon::before {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    line-height: normal;
  }

  .apple {
    --apple-default-icon-size: 15px;
    min-height: calc(var(--apple-default-icon-size) * 17 / 20);
    min-width: var(--apple-default-icon-size);
  }

  .google {
    --google-default-icon-size: 18px;
    min-height: var(--google-default-icon-size);
    min-width: var(--google-default-icon-size);
  }

  .apple-pay {
    --apple-pay-icon-height: var(--icon-size, 24px);
    --apple-pay-icon-width: calc(
      var(--apple-pay-icon-height) * 165.52107 / 105.9651
    );
    max-height: var(--apple-pay-icon-height);
    max-width: var(--apple-pay-icon-width);
    min-height: var(--apple-pay-icon-height);
    min-width: var(--apple-pay-icon-width);
  }

  .google-pay {
    --google-pay-icon-height: var(--icon-size, 38px);
    --google-pay-icon-width: calc(var(--google-pay-icon-height) * 1094 / 742);
    margin: calc(var(--google-pay-icon-height) / 2 * -1)
      calc(var(--google-pay-icon-width) / 10 * -1);
    max-height: var(--google-pay-icon-height);
    max-width: var(--google-pay-icon-width);
    min-height: var(--google-pay-icon-height);
    min-width: var(--google-pay-icon-width);
  }

  .se-bank-id {
    --se-bank-id-icon-size: var(--icon-size, 48px);
    margin: calc(var(--se-bank-id-icon-size) / 2 * -1) 0.25em;
    max-width: var(--se-bank-id-icon-size);
    min-width: var(--se-bank-id-icon-size);
    height: max-content;
  }

  .no-bank-id {
    --no-bank-id-icon-height: var(--icon-size, 16px);
    --no-bank-id-icon-width: calc(var(--no-bank-id-icon-height) * 156 / 24);
    margin: 0 0 -2px 0.25em;
    max-height: var(--no-bank-id-icon-height);
    max-width: var(--no-bank-id-icon-width);
    min-height: var(--no-bank-id-icon-height);
    min-width: var(--no-bank-id-icon-width);
  }

  .dk-mit-id {
    --dk-mit-id-icon-height: var(--icon-size, 18px);
    --dk-mit-id-icon-width: calc(var(--dk-mit-id-icon-height) * 62 / 18);
    margin: 0 0.75em;
    max-height: var(--dk-mit-id-icon-height);
    max-width: var(--dk-mit-id-icon-width);
    min-height: var(--dk-mit-id-icon-height);
    min-width: var(--dk-mit-id-icon-width);
  }

  .bruce {
    max-height: var(--icon-size, 18px);
    max-width: var(--icon-size, 18px);
    min-height: var(--icon-size, 18px);
    min-width: var(--icon-size, 18px);
    margin: 0 0.4em;
  }

  .fi {
    height: var(--icon-size, 36px);
  }
</style>
